// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"503d267b","703":"5f4a13dd"}[chunkId] + ".chunk.js";
};